export enum App_Routes {
  FORWARD_SLASH = '/',
  FORWARD_DOUBLE_SLASH = '//',
  LOGIN = 'login',
  ASSET = 'asset',
  HOME = 'home',
  PLANT = 'plant',
  LIST = 'list',
  TERMS = 'terms',
  IMPRINT = 'imprint',
  ADD_EQUIPMENT = 'add-equipment',
  STRUCTURE_NOT_CREATED = 'structure-not-created',
  STRUCTURE_CREATED = 'structure-created',
  AREA_CREATED = 'area-created',
  CHANGES_IMPLEMENTED = 'changes-implemented',
  CHANGES_NOT_IMPLEMENTED = 'changes-not-implemented',
  EDIT_PLANT = 'edit-plant',
  NOTIFICATIONS = 'notifications',
  SETTINGS = 'settings',
  SENSOR_VALUE = 'sensor-value',
  SENSOR_HEALTH = 'sensor-health',
  DISABLE_ASSETS = 'disabledassets',
  PLANT_EDGE_DEVICE_PATH = 'plant/edge-device/',
  PLANT_EDGE_DEVICE_CENTER = 'plant/edge-device-center',
  LOGIN_REF_AUTH_PATH = '/login/refauth/',
  LOGIN_WITH_CREDENTIALS_PATH = 'api/auth/loginViaCredentials',
  AUTHORIZE_ACCESS_TOKEN_PATH = 'api/auth/AuthorizeAccessToken',
  AUTHORIZE_MSAL_TOKEN_PATH = 'api/auth/AuthorizeMsalToken',
  FORGOT_PW_PATH = 'api/auth/forgotPW',
  CHECK_FORGOT_PW_TOKEN_PATH = 'api/auth/checkForgotPWToken',
  CHANGE_PW_PATH = 'api/auth/changePW',
  SETTING_CHANGE_PW_PATH = 'api/settings/changePW',
  LOGIN_VIA_TOKEN_PATH = 'api/auth/loginViaToken',
  SIGNUP_PATH = 'api/auth/signup',
  PROCESS_REGISTRATION_PATH = 'api/auth/process-registration',
  TELEMETRY_PATH = 'api/telemetry/',
  SENSOR_CONNECT = 'sensor-connect',
  SENSOR_CONNECT_V2 = 'sensor-connect-v2',
  MATCH_SENSOR = 'match-sensor',
  EDIT_EQUIPMENT = 'edit-equipment',
  CREATED = 'created',
  PW_CHANGED = 'pw-changed',
  HOME_IMPLEMENTED = 'home/implemented',
  IMPLEMENTED = 'implemented',
  PLANT_CREATE = 'plant-create',
  PLANT_CREATED = 'plant-created',
  SET_STRUCTURE = 'set-structure',
  EDIT_SENSOR = 'edit-sensor',
  FILTER = 'filter',
}
